import { ComponentType, createElement, lazy } from 'react'

import { ILazyWithPreload, TPageType } from 'models/common.model'

import { ID_TO_PAGE_MAP, PageId } from 'page-constants'

export function lazyWithPreload<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
) {
  let LoadedComponent: T | undefined
  let factoryPromise: Promise<void> | undefined

  const LazyComponent = lazy(factory)

  const loadComponent = () =>
    factory().then((module) => {
      LoadedComponent = module.default
    })

  const Component = ((props) =>
    createElement(LoadedComponent || LazyComponent, props)) as ILazyWithPreload

  Component.preload = () => factoryPromise || loadComponent()

  return Component
}

export function preloadPage(pageId: PageId) {
  const nextPageComponent: TPageType = ID_TO_PAGE_MAP[pageId]
  if ('preload' in nextPageComponent && nextPageComponent.preload) {
    nextPageComponent.preload()
  }
}
